import { useAppSelector } from '@/hooks/store'
import { BookingAvailability } from '@/store/bookingAvailabilitySlice'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { reservationPricesSelector } from '@/store/cartSlice/selectors/reservationPricesSelector.ts'
import { servicesWithCartQuantitySelector } from '@/store/cartSlice/selectors/servicesWithCartQuantitySelector'
import { licenseSlice } from '@/store/licenseSlice'

export const useEcommerceItems = () => {
  const license = useAppSelector(licenseSlice.selectors.license)
  const cartReservations = useAppSelector(cartSlice.selectors.cartReservations)
  const servicesWithCartQuantity = useAppSelector(
    servicesWithCartQuantitySelector
  )
  const selectedBookingType = useAppSelector(
    cartSlice.selectors.selectedBookingType
  )
  const reservationPrices = useAppSelector(reservationPricesSelector)

  const sharedData = {
    Citta: license?.beach.city,
    Provincia: license?.beach.state,
    Regione: license?.beach.region,
    Stabilimento: license?.beach.name ?? license?.license,
    Subregion: license?.beach.subregion,
    currency: 'EUR',
  }

  const isBookingTypeTickets =
    selectedBookingType === BookingAvailability.TICKETS

  if (isBookingTypeTickets) {
    return servicesWithCartQuantity
      .map((group) =>
        group.services.map((ticket) => {
          return {
            Prezzo: ticket.price * (ticket.quantity ?? 1),
            item_brand: 'ticket',
            item_id: ticket.serviceId,
            item_name: ticket.name,
            quantity: ticket.quantity,
            ...sharedData,
          }
        })
      )
      .flat()
  }

  return cartReservations?.map((reservation) => {
    return {
      Prezzo:
        reservationPrices[`_${reservation.spotType}_${reservation.spotName}`],
      item_brand: reservation.spotType,
      item_id: reservation.spotName,
      item_name: reservation.spotName,
      quantity: 1,

      ...sharedData,
    }
  })
}
